import React from 'react'
import win from "../assets/images/win.png";
import Wallpaper1 from "../assets/images/wallpaper1.jpg";

function LostScreen() {
    return (
        <div className="result-block">
            <p>Thanks for participating</p>
            <h2>Prize Unlocked</h2>
            <div className="poster">
                <div className="overlay-text">
                    <p>A customised wallpaper (to the theme of Raabta)</p>
                    click{" "}
                    <a href={Wallpaper1} download="Raabta-Wallpaper.jpg">
                        here
                    </a>{" "}
                    to download
                </div>
            </div>
            <img className="win-img" src={win} alt="logo-prize" />
        </div>
    )
}

export default LostScreen